import Vue from 'vue';
import VueRouter from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(VueRouter);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'transaction' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};
const menu_available = (to, from, next) => {
	if (auth.getUserData().stockist_type == 'utama') {
		next();
	} else {
		const menu = auth.getUserData().stockist_menu
		if (menu.includes(to.name)) {
			next()
		} else {
			next({ name: 'transaction' });
		}
	}
};

const routes = [
{
	path: '/auth',
	component: () =>
		import ('@/views/layout/Auth.vue'),
	children:[{
		path: 'autologin',
		name: 'autologin',
		beforeEnter: isUnauth,
		component: () =>
			import ('@/views/auth/AutoLogin.vue'),
	}]
},	
{
	path: '/auth',
	component: () =>
		import ('@/views/layout/Auth.vue'),
	children: [{
		path: 'login',
		name: 'login',
		beforeEnter: isUnauth,
		component: () =>
			import ('@/views/auth/Login.vue'),
	}, {
		path: 'sso/:token',
		name: 'sso',
		component: () =>
			import ('@/views/sso/Sso.vue'),
	}],
}, {
	path: '/',
	component: () =>
		import ('@/views/layout/Main.vue'),
	beforeEnter: isAuth,
	children: [{
		path: '/',
		name: 'dashboard',
		component: () =>
			import ('@/views/dashboard/Dashboard.vue'),
	}, {
		path: '/stock-history',
		name: 'stock-history',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/inventory/StockHistory.vue'),
	}, {
		path: '/stock-serial',
		name: 'stock-serial',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/inventory/StockSerial.vue'),
	}, {
		path: '/stock-serial-convert',
		name: 'stock-serial-convert',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/inventory/covertStockSerial.vue'),
	}, {
		path: '/transaction',
		name: 'transaction',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/transaction/Transaction.vue'),
	// }, {
	// 	path: '/register',
	// 	name: 'register',
	// 	beforeEnter: menu_available,
	// 	component: () =>
	// 		import ('@/views/transaction/Register.vue'),
	}, {
		path: '/sales-report',
		name: 'sales-report',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/report/SalesReport.vue'),
	}, {
		path: '/sales-report-new',
		name: 'sales-report-new',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/report/SalesReportNew.vue'),
	}, {
		path: '/sales-analysis',
		name: 'sales-analysis',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/report/SalesAnalysis.vue'),
	}, {
		path: '/new-mitra-report',
		name: 'new-mitra-report',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/report/NewMitraReport.vue'),
	}, {
		path: '/follow-up',
		name: 'follow-up',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/followup/FollowUp.vue'),
	}, {
		path: '/profile',
		name: 'profile',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/setting/Profile.vue'),
	}, {
		path: '/setting-edc',
		name: 'setting-edc',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/setting/Edc.vue'),
	}, {
		path: '/setting-address',
		name: 'setting-address',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/setting/Address.vue'),
	}, {
		path: '/setting-pin',
		name: 'setting-pin',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/setting/Pin.vue'),
	}, {
		path: '/setting-password',
		name: 'setting-password',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/setting/Password.vue'),
	}, {
		path: 'receipt',
		name: 'receipt',
		component: () => import ('@/views/receipt/Receipt.vue'),
	}, {
		path: 'receipt/:slug',
		name: 'receipt-detail',
		component: () => import ('@/views/receipt/DetailReceipt.vue'),
	}, {
		path: 'receipt-serial/:slug',
		name: 'receipt-serial-detail',
		component: () => import ('@/views/receipt/ReceiptSerial.vue'),
	}, {
		path: 'convert-serial',
		name: 'convert-serial',
		component: () => import ('@/views/serial/ConvertSerial.vue'),
	}, {
		path: 'data-convert-serial',
		name: 'data-convert-serial',
		component: () => import ('@/views/serial/DataConvertSerial.vue'),
	},{
		path: '/purchase-order',
		name: 'purchase-order',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/po/PurchaseOrder.vue'),
	},
	{
		path: '/purchase-order-list',
		name: 'purchase-order-list',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/po/PurchaseOrderList.vue'),
	},
	{
		path: '/stock-serial-digital',
		name: 'stock-serial-digital',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/inventory/StockSerialDigital.vue'),
	},
	{
		path: '/voucher',
		name: 'voucher',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/voucher/ListVoucher.vue'),
	},
	{
		path: '/voucher-promo',
		name: 'voucher-promo',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/voucher/VoucherRamadhan.vue'),
	},
	{
		path: '/tutorial',
		name: 'tutorial',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/tutorial/ListTutorial.vue'),
	},
	{
		path: '/tutorial-detail/:id',
		name: 'tutorial-detail',
		beforeEnter: menu_available,
		component: () =>
			import ('@/views/tutorial/TutorialDetail.vue'),
	}
],
}, {
	path: '*',
	beforeEnter: (to, from, next) => {
		next('/')
	}
}];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	linkExactActiveClass: 'exact-active',
	linkActiveClass: 'active',
	routes,
});

export default router;
